"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountLinkPreviewSettings = void 0;
var react_1 = __importDefault(require("react"));
var LinkPreviewSettings_1 = require("./LinkPreviewSettings");
function mountLinkPreviewSettings(createUi, canEdit, overlayStack, linkPreviewSettingsStore, projectId, $state, usingFeature, mountReactComponent) {
    var props = {
        canEdit: canEdit,
        linkPreviewSettingsStore: linkPreviewSettingsStore,
        projectId: projectId,
        usingFeature: usingFeature,
    };
    var linkPreviewSettingsInner = mountReactComponent(react_1.default.createElement(LinkPreviewSettings_1.LinkPreviewSettings, __assign({ defaultSettingsOnClick: function () {
            overlayStack.closeCurrent();
            $state.go("settings", { section: "link-preview" });
        } }, props)));
    return createUi(require("./LinkPreviewSettings.html"), { linkPreviewSettingsInner: linkPreviewSettingsInner });
}
exports.mountLinkPreviewSettings = mountLinkPreviewSettings;
